"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchSUMOCEPUserSaga = void 0;
const constants_1 = require("@/app/shared/constants");
const helpers_1 = require("@/app/shared/helpers");
const serverError_1 = require("@/app/shared/helpers/serverError");
const analyticsService_1 = require("@/app/shared/services/analyticsService");
const global_1 = require("@/app/shared/store/global");
const notifications_1 = require("@/app/shared/store/notifications");
const reduxUtils_1 = require("@/app/shared/store/reduxUtils");
const server_1 = require("@/app/SUMOCEP/server");
const effects_1 = require("redux-saga/effects");
const actions_1 = require("../scheduler/actions");
const actions_2 = require("./actions");
const selectors_1 = require("./selectors");
const utils_1 = require("./utils");
function* initializeUser(action) {
    if (action.type !== actions_2.SUMOCEPUserActionTypes.INITIALIZE_USER)
        return;
    try {
        const isAuthorized = yield (0, effects_1.call)(server_1.SalesForceServer.isAuthorized);
        yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.setIsAuthorized(isAuthorized));
        if (isAuthorized) {
            yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.getAuthenticationRequest());
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.getAuthenticationFail());
        yield (0, effects_1.put)(global_1.globalActions.handleLogout());
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.USER_DEACTIVATED_ERROR_MESSAGE);
    }
}
function* getAuthenticationRequest(action) {
    if (action.type !== actions_2.SUMOCEPUserActionTypes.GET_AUTHENTICATION_REQUEST)
        return;
    try {
        const responce = yield (0, effects_1.call)(server_1.SalesForceServer.getAuthenticationResponse);
        if (responce) {
            if (responce?.tenant) {
                yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.setIsLicenseValid((0, utils_1.checkLicenseValidity)(responce)));
            }
            if (responce?.userData) {
                yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.setUser(responce.userData));
            }
            if (responce?.role?.name) {
                yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.setRole(responce.role.name));
            }
            yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.getAuthenticationSuccess());
            analyticsService_1.analyticsService.trackAuthCompleted();
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.getAuthenticationFail());
        yield (0, effects_1.put)(global_1.globalActions.handleLogout());
        if ((0, serverError_1.isCorsOrNetworkError)(error)) {
            yield (0, effects_1.put)(notifications_1.notificationsActions.showToast({ id: constants_1.TOAST_ERROR_ID.CORS_CONFIGURATION_REQUIRED }));
        }
        else {
            yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.GET_USER_LOGIN_ERROR_MESSAGE);
        }
    }
}
function* getLoginWithSalesforceRequest(action) {
    if (action.type !== actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_REQUEST)
        return;
    const isOutlookAddon = !!window?.Office?.context?.ui;
    try {
        const response = yield (0, effects_1.call)(server_1.SalesForceServer.getSalesforceAccessToken, {
            env: action.payload,
            isOutlookAddon,
        });
        if (response) {
            const isAuthorized = yield (0, effects_1.select)(selectors_1.SUMOCEPUserSelectors.selectIsAuthorized);
            helpers_1.Storage.Local.set(helpers_1.Storage.Key.SERVER_ENVIRONMENT, action.payload);
            yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.getLoginWithSalesforceSuccess());
            yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.getLoginWithSalesforceAuthorizationRequest({
                isAuthorized,
                isOutlookAddon,
                env: action.payload,
            }));
            yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.getPrefixRequest());
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.getLoginWithSalesforceFail());
    }
}
function* getLoginSalesforceAuthorizationCodeRequest(action) {
    if (action.type !== actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_REQUEST)
        return;
    try {
        const user = yield (0, effects_1.call)(server_1.SalesForceServer.loginWithSalesforceAuthorizationCode, action.payload);
        if (user) {
            yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.getLoginWithSalesforceAuthorizationSuccess(action.payload.env));
        }
    }
    catch (error) {
        yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.getLoginWithSalesforceAuthorizationFail());
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.GET_USER_LOGIN_ERROR_MESSAGE);
    }
}
function* getPrefixRequest(action) {
    if (action.type !== actions_2.SUMOCEPUserActionTypes.GET_PREFIX_REQUEST)
        return;
    try {
        const response = yield (0, effects_1.call)(server_1.SalesForceServer.getPrefixRequest);
        const prefix = response?.records?.[0]?.NamespacePrefix ?? '';
        helpers_1.Storage.Local.set(helpers_1.Storage.Key.SERVER_PREFIX, prefix);
        yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.getPrefixRequestSuccess());
    }
    catch (error) {
        yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.getPrefixRequestFail());
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.GET_USER_LOGIN_ERROR_MESSAGE);
    }
}
function* handleLogout(action) {
    if (action.type !== actions_2.SUMOCEPUserActionTypes.HANDLE_LOGOUT)
        return;
    try {
        const isLoggedOut = yield (0, effects_1.call)(server_1.SalesForceServer.logout);
        if (isLoggedOut) {
            analyticsService_1.analyticsService.reset();
            yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.resetWholeStore());
            yield (0, effects_1.put)(actions_1.SUMOCEPSchedulerActions.resetWholeStore());
            yield (0, effects_1.put)(global_1.globalActions.setIsAuthorized(false));
            yield (0, effects_1.call)(helpers_1.ExtensionRuntime.sendMessage, { type: constants_1.RegularMessage.SCHEDULER_LOGOUT });
            yield (0, effects_1.call)(helpers_1.ExtensionRuntime.sendMessage, { type: constants_1.RegularMessage.SCHEDULER_DIALOG_CLOSE });
        }
    }
    catch (error) {
        console.error('Logout failed:', error);
    }
}
// Root saga
function* watchSUMOCEPUserSaga() {
    yield (0, effects_1.takeLatest)(actions_2.SUMOCEPUserActionTypes.INITIALIZE_USER, initializeUser);
    yield (0, effects_1.takeLatest)(actions_2.SUMOCEPUserActionTypes.GET_AUTHENTICATION_REQUEST, getAuthenticationRequest);
    yield (0, effects_1.takeLatest)(actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_REQUEST, getLoginWithSalesforceRequest);
    yield (0, effects_1.takeLatest)(actions_2.SUMOCEPUserActionTypes.GET_LOGIN_WITH_SALESFORCE_AUTHORIZATION_CODE_REQUEST, getLoginSalesforceAuthorizationCodeRequest);
    yield (0, effects_1.takeLatest)(actions_2.SUMOCEPUserActionTypes.GET_PREFIX_REQUEST, getPrefixRequest);
    yield (0, effects_1.takeLatest)(actions_2.SUMOCEPUserActionTypes.HANDLE_LOGOUT, handleLogout);
}
exports.watchSUMOCEPUserSaga = watchSUMOCEPUserSaga;
